import { useEffect, useState } from 'react';
import { database } from '../firebaseConfig2';
import { collection, onSnapshot  } from "firebase/firestore"; 
import { memo } from 'react';



const Home = memo(function Home(props) {
  console.log("Home.js");
  const [lastUpdated, setLastUpdated] = useState("null");
  // console.log();
  const groupedByCountry = Object.groupBy(props.fansList, item => item.country);
  
  useEffect(
      () =>
        onSnapshot(collection(database, "stp_stats"), (snapshot) => {
          snapshot.forEach((doc) => {

            setLastUpdated(doc.data().date);
            
          });
  
          }),
      []
    );


  return (
    <div className='home-positioner'>
       {/* <div className='site-desc'>
        <p>Welcome to <span style={{color:'red'}}>Path in the Woods</span>, the TheFanlistings.org approved fanlisting for Slay the Princess.
        <br/>If you're a fan of the game, please consider adding yourself to the list of fans.</p>
       </div> */}
       <div className='stats-bg'></div>
       <div className='stats'>
             <p id="site-blurb">Welcome to <span style={{color:'#cd4340'}}>Path in the Woods</span>, a fanlisting for the game <a style={{fontStyle: 'italic'}} target="_blank" rel="noopener noreferrer" href="/stp">Slay the Princess</a>.
              <br/> <br/>If you're a fan of the game, please consider <a target="_blank" rel="noopener noreferrer" href="/join">adding yourself</a> to the <a target="_blank" rel="noopener noreferrer" href="/fans">list of fans</a>.</p>
            
            <div id="blurb-stats">
              <p>Listed on: the <a target="_blank" rel="noopener noreferrer" href="https://thefanlistings.org/">TheFanlistings.org</a></p>
              <p><span style={{color:'#da5959'}}>{props.fansList.length}</span> fans from <span style={{color:'#da5959'}}>{Object.keys(groupedByCountry).length}</span> countries</p>
              <p>Last updated: <span style={{color:'#da5959'}}>{lastUpdated}</span></p>
              <p>Newest members: <span style={{color:'#da5959'}}>{(props.fansList.at(-1) === undefined) ? "Loading..." : props.fansList.at(-1).name}</span> </p>
            </div>
       </div>
        <div className = "on-a-path">
            <div className='on-a-path-title'>The Narrator</div>
            <div className='on-a-path-text'>
                You're on a path in the woods. And at the end of that path is a cabin. And in the basement of that cabin is a princess.
                </div>
            {/* <div className='arrow-blinking'></div> */}
        </div>
    </div>
        // {/* <div className='site'>
        //   <h2>Welcome message</h2>
        //   <p>Welcome to <span style={{color:'red'}}>Path in the Woods</span>, the TheFanlistings.org approved fanlisting for Slay the Princess.
        //   If you're a fan of the game, please consider adding yourself to the list of fans.</p>
        //     <div className='stats'>
        //       
        //     </div>
        // </div> */}
  );
});

export default Home;